var _ellipse, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForexSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 18.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 29.5 18.5)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.601 103.509C168.051 103.674 168.05 104.326 167.601 104.491C161.726 106.641 159.641 108.725 157.49 114.601C157.326 115.05 156.674 115.05 156.509 114.601C154.357 108.728 152.274 106.644 146.399 104.491C145.949 104.326 145.95 103.674 146.399 103.509C152.274 101.359 154.359 99.2747 156.51 93.3992C156.674 92.9498 157.326 92.9496 157.491 93.399C159.643 99.2723 161.726 101.356 167.601 103.509Z",
    fill: "url(#paint0_linear_40000002_53736)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 14,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 170 14)",
    fill: "#F2E9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5005 26.3828C79.6828 22.1455 88.0578 19.7144 97.0006 19.7144C123.668 19.7144 145.286 41.3326 145.286 68.0001C145.286 94.6679 123.668 116.286 97.0006 116.286C70.3331 116.286 48.7148 94.6679 48.7148 68.0001C48.7148 65.9681 48.8404 63.9655 49.084 61.9995",
    stroke: "url(#paint1_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.708 42H107.994C104.054 42 100.275 43.5653 97.4883 46.3516C94.702 49.1378 93.1367 52.9168 93.1367 56.8571C93.1367 60.7975 94.702 64.5765 97.4883 67.3627C100.275 70.149 104.054 71.7143 107.994 71.7143C109.964 71.7143 111.854 72.497 113.247 73.89C114.64 75.2832 115.422 77.1727 115.422 79.1429V112.571",
    stroke: "url(#paint2_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3086 75.4287H67.2858C71.2261 75.4287 75.0051 76.994 77.7913 79.7803C80.5776 82.5665 82.1429 86.3455 82.1429 90.2858V113.983",
    stroke: "url(#paint3_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.413 44.358C67.9783 44.358 67.6261 44.005 67.6261 43.5696C67.6261 43.1342 67.9783 42.7813 68.413 42.7813",
    stroke: "url(#paint4_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.413 44.358C68.8474 44.358 69.2002 44.005 69.2002 43.5696C69.2002 43.1342 68.8474 42.7813 68.413 42.7813",
    stroke: "url(#paint5_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8133 44.358C41.3787 44.358 41.0264 44.005 41.0264 43.5696C41.0264 43.1342 41.3787 42.7813 41.8133 42.7813",
    stroke: "url(#paint6_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8133 44.358C42.248 44.358 42.6005 44.005 42.6005 43.5696C42.6005 43.1342 42.248 42.7813 41.8133 42.7813",
    stroke: "url(#paint7_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49.4483C58.0606 49.4483 60.5417 46.9627 60.5417 43.8966C60.5417 40.8304 58.0606 38.3448 55 38.3448C51.9394 38.3448 49.4583 40.8304 49.4583 43.8966C49.4583 46.9627 51.9394 49.4483 55 49.4483Z",
    stroke: "url(#paint8_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 32H39.1667C37.4178 32 36 33.373 36 35.0667V51.9333C36 53.6271 37.4178 55 39.1667 55H70.8333C72.5823 55 74 53.6271 74 51.9333V35.0667C74 33.373 72.5823 32 70.8333 32Z",
    stroke: "url(#paint9_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42H30",
    stroke: "url(#paint10_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47L30 47",
    stroke: "url(#paint11_linear_40000002_53736)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40000002_53736",
    x1: 168.727,
    y1: 103.803,
    x2: 129.531,
    y2: 116.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40000002_53736",
    x1: 144.189,
    y1: 67.2085,
    x2: -13.5276,
    y2: 120.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40000002_53736",
    x1: 137.202,
    y1: 76.7072,
    x2: 59.6665,
    y2: 93.1899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40000002_53736",
    x1: 81.7698,
    y1: 94.3898,
    x2: 26.604,
    y2: 110.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40000002_53736",
    x1: 73.5682,
    y1: 43.3115,
    x2: 20.7968,
    y2: 72.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40000002_53736",
    x1: 73.5682,
    y1: 43.3115,
    x2: 20.7968,
    y2: 72.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40000002_53736",
    x1: 73.5682,
    y1: 43.3115,
    x2: 20.7968,
    y2: 72.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40000002_53736",
    x1: 73.5682,
    y1: 43.3115,
    x2: 20.7968,
    y2: 72.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40000002_53736",
    x1: 73.5682,
    y1: 43.3115,
    x2: 20.7968,
    y2: 72.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_40000002_53736",
    x1: 73.5682,
    y1: 43.3115,
    x2: 20.7968,
    y2: 72.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_40000002_53736",
    x1: 29.8636,
    y1: 42.4918,
    x2: 28.6035,
    y2: 47.5816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_40000002_53736",
    x1: 29.9205,
    y1: 47.4918,
    x2: 27.9777,
    y2: 52.0691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForexSend);
export default __webpack_public_path__ + "static/media/forexSend.96703f45aaf4946c6b90818c7b9ea6db.svg";
export { ForwardRef as ReactComponent };